import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionsKey } from "../data/permissions";
export type UserRole = "ADMIN" | "STORE" | "OWNER" | "ORGANIZER" | "CUSTOMER" | "ORGANIZATION" | null;

export interface AuthState {
    accessToken: string | null;
    role: UserRole;
    permissions: PermissionsKey[];
    status: "idle" | "loading" | "succeeded" | "failed";
    deviceId: string | null;
}
const initialState: AuthState = {
    accessToken: null,
    role: null,
    permissions: [],
    status: "idle",
    deviceId: null,
};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCredentials(
            state,
            action: PayloadAction<{ accessToken: string; role: Exclude<UserRole, null> }>
        ) {
            state.accessToken = action.payload.accessToken;
            state.role = action.payload.role;
            state.status = "succeeded";
        },

        setPermissions(
            state,
            action: PayloadAction<{ permissions: PermissionsKey[] }>
        ) {
            state.permissions = action.payload.permissions;
        },

        logoutAuth(state) {
            state.accessToken = null;
            state.role = null;
            state.permissions = [];
            state.status = "idle";
            state.deviceId = null;
        },

        setDeviceIdAction(
            state,
            action: PayloadAction<{ deviceId: string }>
        ) {
            state.deviceId = action.payload.deviceId;
        },
    },
});

export const { setCredentials, setPermissions, logoutAuth, setDeviceIdAction } = authSlice.actions;
export default authSlice.reducer;
